export class MentidadHechoC {
    select_entidades: string;
    select_provincia: string;
    select_distrito: string;
    select_departamento: string;
    flg_deshabilita = true;
    inputDireccion: string;
    inputReferencia: string;

}

